import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ConstructorContent as SchemaConstructorContent } from '../schemas/ConstructorContent';
import { type NewConstructorContent as SchemaNewConstructorContent } from '../schemas/NewConstructorContent';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Constructor
 */
export const UpdateConstructorContentContentType = 'application/json' as const;
export type UpdateConstructorContentRequest = SchemaNewConstructorContent;
export type UpdateConstructorContentResponses = LinkCommonErrorResponses & {
    /**
     * @description Constructor content updated successfully
     */
    '200': {
        'application/json': SchemaConstructorContent;
    };
};
export type UpdateConstructorContentResponseSuccess = UpdateConstructorContentResponses['200']['application/json'];
export type UpdateConstructorContentSearchParams = undefined;
export type UpdateConstructorContentPathParameters = undefined;
export const UpdateConstructorContentUrl = '/constructor/content' as const;
export const UpdateConstructorContentMethod = 'PUT' as const;
export const getUpdateConstructorContentUrl = (_params?: UpdateConstructorContentPathParameters) =>
    UpdateConstructorContentUrl;
